import { dteConfigurationApi } from '../../api';
import { DTEConfigurationForm } from '../../types/hacienda/DTEConfigurationTypes';

const DTEConfigurationService = {
  /**
   * Obtiene la configuración actual de Hacienda.
   * GET /api/dte-configuration
   */
  getConfiguration: async () => {
    const response = await dteConfigurationApi.fetchAll();
    return response.data;
  },

  /**
   * Crea la configuración de Hacienda.
   * POST /api/dte-configuration
   */
  createConfiguration: async (data: DTEConfigurationForm) => {
    const response = await dteConfigurationApi.add(data);
    return response.data;
  },

  /**
   * Actualiza la configuración de Hacienda.
   * PUT /api/dte-configuration/{id}
   */
  updateConfiguration: async (id: number, data: DTEConfigurationForm) => {
    const response = await dteConfigurationApi.modify(id, data);
    return response.data;
  },

  /**
   * Lista los ambientes disponibles para dropdown.
   * GET /api/dte-configuration/environments
   */
  getEnvironments: async () => {
    const response = await dteConfigurationApi.fetchCustom('/environments');
    return response.data;
  },

  /**
   * Lista las monedas disponibles para dropdown.
   * GET /api/dte-configuration/currencies
   */
  getCurrencies: async () => {
    const response = await dteConfigurationApi.fetchCustom('/currencies');
    return response.data;
  },

  /**
   * Lista los modelos de facturación disponibles para dropdown.
   * GET /api/dte-configuration/billing-models
   */
  getBillingModels: async () => {
    const response = await dteConfigurationApi.fetchCustom('/billing-models');
    return response.data;
  },

  /**
   * Lista los tipos de transmisión disponibles para dropdown.
   * GET /api/dte-configuration/transmission-types
   */
  getTransmissionTypes: async () => {
    const response = await dteConfigurationApi.fetchCustom('/transmission-types');
    return response.data;
  }
};

export default DTEConfigurationService;
